import React, { useEffect, useState } from "react";
//img
import bellIcon from "../../../assets/images/svg/Notification.svg";
//css
import classes from "./NotificationBell.module.css";
import { CircularProgress, Drawer } from "@mui/material";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux";
import { Close } from "@mui/icons-material";
import NotificationCard from "./NotificationCard";

const NotificationBell = () => {
  //getting data from use selector
  const loginData = useSelector((state) => state.loginData.value);

  const [auth_token, setAuthToken] = useState(loginData?.auth_token);
  const [unique_token, setUniqueToken] = useState(loginData?.user?.token);
  const [vendor_token, setVendorToken] = useState(loginData?.vendor_contact_token);
  const [loadingState, setLoadingState] = useState(false);

  // opensidebar
  const [openNotificationBar, setOpenNotificationBar] = useState(false);
  const handleOpenNotificationBar = () => setOpenNotificationBar(true);
  const handleCloseNotificationBar = () => setOpenNotificationBar(false);

  const [notificationsData, setNotificationData] = useState([]);
  const [approvalNotificationData, setApprovalNotificationData] = useState([]);
  const [userNotifications, setUserNotifications] = useState('');
  const [viewOption, setViewOption] = useState("All");

  const [usermessagetoken, setUserMessageToken] = useState(loginData?.user?.user_token)
  const [getusermessages, setUserMessages] = useState([])

  const handleOptionChange = (e) => {
    let val = e?.target?.value;
    setViewOption(val);
  };



  let org_buyer_access =
    loginData?.access_type === "Buyer" ||
    loginData?.access_type === "Admin" ||
    loginData?.access_type === "buyer" ||
    loginData?.access_type === "admin";

  let user_access =
    loginData?.access_type === "User" ||
    loginData?.access_type === "user";

  let vendor_access =
    loginData?.access_type === "vendor admin" ||
    loginData?.access_type === "vendor contact";

  let vendor_admin_access = loginData?.access_type === "vendor admin";
  let vendor_contact_access = loginData?.access_type === "vendor contact";

  const getuserMessages = async () => {
    const formData = new FormData()

    usermessagetoken && formData?.append("user_token", usermessagetoken)

    await axios({
      method: "POST",
      data: formData,
      url: `${API_ENDPOINT.get_user_messages}`,
      headers: {
        Authorization: `Bearer ${auth_token}`
      }
    }).then((res) => {
      setUserMessages(res?.data)
    })

  }

  useEffect(() => {

    if (user_access) {
      getuserMessages()
    }

  }, [])

  const getNotifications = async () => {
    const formData = new FormData();

    org_buyer_access && formData?.append("buyer_token", unique_token);
    vendor_access && formData?.append("vendor_token", unique_token);

    await axios({
      method: "POST",
      url: `${API_ENDPOINT.getNotifications}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        // setNotificationData(res?.data?.response);
        const filteredNotifications = (res?.data?.response || []).filter(notification => notification.message);
        setNotificationData(filteredNotifications);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const approvalNotifications = async () => {
    const formData = new FormData();

    org_buyer_access && formData?.append("buyer_token", unique_token);
    user_access && formData?.append("user_token", unique_token)

    await axios({
      method: "POST",
      url: `${API_ENDPOINT.approvalNotifications}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {

        // setApprovalNotificationData(res?.data?.notifications || []);
        const notifications = res?.data?.notifications || res?.data?.status != "error" && res?.data;
        if (notifications) {
          // Check if notifications is an array
          if (Array.isArray(notifications)) {

            setApprovalNotificationData(notifications);
          } else {
            // If it's a single object, wrap it in an array
            setApprovalNotificationData([notifications]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const mergeAndSortNotifications = () => {
    const combinedData = [...approvalNotificationData, ...notificationsData];
    // const sortedData = combinedData.sort((a, b) => new Date(b.created) - new Date(a.created));
    const sortedData = combinedData.sort((a, b) => {
      const dateA = new Date(a.created);
      const dateB = new Date(b.created);
      return dateB - dateA;
    });

    return sortedData;

  };

  const notificationClick = async (notification_id, markAsAllReadKeys) => {
    const formData = new FormData();
    notification_id && formData.append("notify_id", notification_id);

    markAsAllReadKeys &&
      markAsAllReadKeys?.forEach((element) => {
        return formData.append(element.key, element.value);
      });

    await axios({
      method: "POST",
      url: `${API_ENDPOINT.unreadNotifications}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);
        getNotifications();
        approvalNotifications();
      })
      .catch((err) => {
        setLoadingState(false);
        console.log(err);
      });
  };

  const markAsAllRead = () => {
    setLoadingState(true);
    if (org_buyer_access) {
      notificationClick(null, [
        {
          key: "buyer_token",
          value: unique_token,
        },
      ]);
    }
    if (user_access) {
      notificationClick(null, [
        {
          key: "user_token",
          value: unique_token,
        },
      ]);
    }
    if (vendor_admin_access) {
      notificationClick(null, [
        {
          key: "vendor_token",
          value: vendor_token,
        },
      ]);
    }
    if (vendor_contact_access) {
      notificationClick(null, [
        {
          key: "vendor_token",
          value: unique_token,
        },
      ]);
    }
  };

  useEffect(() => {
    getNotifications();
    approvalNotifications();
  }, []);

  const combinedNotifications = mergeAndSortNotifications();

  return (
    <div className={`${classes.notification_wrapper} ${classes.flex}`}>
      <div
        className={`${classes.notification_icon} ${combinedNotifications &&
            combinedNotifications?.some((notification) => !notification.status)
            ? `${classes.active}`
            : ""
          }`}
        onClick={handleOpenNotificationBar}
      >
        <img src={bellIcon} />
        {combinedNotifications &&
          combinedNotifications?.some((notification) => !notification.status) && (
            <span className={`${classes.notification_indicator}`}></span>
          )}
      </div>

      <Drawer
        open={openNotificationBar}
        anchor={"right"}
        className={classes.menuDraw}
      >
        <div className={`${classes.notification_panel}`}>
          <div className={`${classes.notificationHeader}`}>
            <span>Notifications</span>
            <Close
              sx={{ fontSize: "3rem", padding: "0.5rem", cursor: "pointer" }}
              className={classes.closeBtn}
              onClick={handleCloseNotificationBar}
            />
          </div>
          <div className={classes.filterOptions}>
            <div className={classes.view}>
              <select
                className={classes.filterDropdown}
                onChange={handleOptionChange}
                value={viewOption}
              >
                <option value="All">All</option>
                <option value="Read">Read</option>
                <option value="Unread">Unread</option>
              </select>
            </div>

            {/* {notificationsData &&
              notificationsData
                ?.map((e) => e?.status)
                ?.filter((e) => e === false)?.length !== 0 && (
                <button
                  className={classes.markAsAllRead}
                  onClick={() => {
                    notificationsData &&
                      notificationsData
                        ?.map((e) => e?.status)
                        ?.filter((e) => e === false)?.length !== 0 &&
                      markAsAllRead();
                  }}
                >
                  {!loadingState ? (
                    "Mark as all read"
                  ) : (
                    <CircularProgress
                      size={"15px"}
                      thickness={6}
                      variant="indeterminate"
                      disableShrink
                      sx={{
                        color: "#fff",
                        animationDuration: "450ms",
                      }}
                    />
                  )}
                </button>
              )} */}
            {combinedNotifications?.filter((e) => e.status === false).length !== 0 && (
              <button
                className={classes.markAsAllRead}
                onClick={markAsAllRead}
              >
                {!loadingState ? (
                  "Mark as all read"
                ) : (
                  <CircularProgress
                    size={"15px"}
                    thickness={6}
                    variant="indeterminate"
                    disableShrink
                    sx={{
                      color: "#fff",
                      animationDuration: "450ms",
                    }}
                  />
                )}
              </button>
            )}
          </div>

          <NotificationCard
            notificationsData={!user_access ? combinedNotifications : getusermessages}
            filter={viewOption}
            notificationClick={notificationClick}
          />
        </div>
      </Drawer>
    </div>
  );
};

export default NotificationBell;